import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import styles from './PdpRespIconBubbles.scss';

// Components
import TooltipLoader from '../../global/TooltipLoader';
import { FormattedMessage } from 'react-intl';
import PrintIcon from 'dibs-vg/dist/react/print';

// redux actions
import { printActions } from '../../actions/pdpRespPrintActions';

// helpers
import { trackPrintNoPriceClick, trackPrintWithPriceClick } from '../tracking/iconBubblesTracking';

// messages
const print = <FormattedMessage id="PdpRespIconBubblePrint.print" defaultMessage="Print" />;
const printNoPrice = (
    <FormattedMessage
        id="PdpRespIconBubblePrint.printNoPrice"
        defaultMessage="Print without Price"
    />
);

class PdpRespIconBubblePrint extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showTooltip: false };
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.onClickPrintWithPrice = this.onClickPrintWithPrice.bind(this);
        this.onClickPrintWithoutPrice = this.onClickPrintWithoutPrice.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (this.props.pdpPrint.triggerWindowPrint && !prevProps.pdpPrint.triggerWindowPrint) {
            window.print();
            this.props.updateTriggerWindowPrint();
        }
    }
    showTooltip() {
        this.setState({ showTooltip: true });
    }
    hideTooltip(cb) {
        this.setState({ showTooltip: false }, cb);
    }
    onClickPrintWithPrice(e) {
        e.stopPropagation();
        trackPrintWithPriceClick();
        this.hideTooltip(() => this.props.updateToPrintWithPrice());
    }
    onClickPrintWithoutPrice(e) {
        e.stopPropagation();
        trackPrintNoPriceClick();
        this.hideTooltip(() => this.props.updateToPrintWithoutPrice());
    }
    render() {
        const { showTooltip } = this.state;

        return (
            <div className={`${styles.bubble} enable-click-on-preview`} onClick={this.showTooltip}>
                {/* Print Icon */}
                <PrintIcon className={styles.icon} />

                {/* Tooltip */}
                <TooltipLoader
                    load={showTooltip}
                    isVisible={showTooltip}
                    closeOnOutsideClick
                    onClose={this.hideTooltip}
                >
                    <span className={styles.printLink} onClick={this.onClickPrintWithPrice}>
                        {print}
                    </span>
                    <span className={styles.printLink} onClick={this.onClickPrintWithoutPrice}>
                        {printNoPrice}
                    </span>
                </TooltipLoader>
            </div>
        );
    }
}

PdpRespIconBubblePrint.propTypes = {
    pdpPrint: PropTypes.shape({
        triggerWindowPrint: PropTypes.bool.isRequired,
    }).isRequired,
    updateToPrintWithPrice: PropTypes.func.isRequired,
    updateToPrintWithoutPrice: PropTypes.func.isRequired,
    updateTriggerWindowPrint: PropTypes.func.isRequired,
};

// Redux Map Functions
function mapStateToProps({ pdpPrint }) {
    return { pdpPrint };
}
function mapDispatchToProps(dispatch) {
    return {
        updateToPrintWithPrice: () => dispatch(printActions.printWithPrice()),
        updateToPrintWithoutPrice: () => dispatch(printActions.printWithoutPrice()),
        updateTriggerWindowPrint: () => dispatch(printActions.windowPrintTriggered()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PdpRespIconBubblePrint);
